"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundValueRow = void 0;
const react_1 = __importDefault(require("react"));
const forms_1 = require("../../forms");
const SoundValueRow_styles_1 = require("./SoundValueRow.styles");
const SoundValueRow = ({ title, valueList, isHeader, translationKey, translationEditHandler, }) => {
    return (react_1.default.createElement(SoundValueRow_styles_1.Row, { "$isHeader": isHeader, "$numberOfColumns": valueList.length },
        translationKey ? (react_1.default.createElement(SoundValueRow_styles_1.Title, null,
            react_1.default.createElement(forms_1.EditableTitle, { name: title, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value, translationKey), isEditable: !!translationKey }))) : (react_1.default.createElement(SoundValueRow_styles_1.Title, null, title)),
        valueList.map((item, index) => (react_1.default.createElement(SoundValueRow_styles_1.Value, { key: index }, item)))));
};
exports.SoundValueRow = SoundValueRow;
//# sourceMappingURL=SoundValueRow.js.map